export class GameConstants {
    static readonly COIN_SYMBOL_ID = 22;
}